var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.disabled || _vm.truncate || _vm.active) ? _c('div', [_vm._t("default", [_c('span', [_vm._v(_vm._s(_vm.text))])])], 2) : _c('div', [(_vm.changeRoute) ? _c('router-link', {
    staticClass: "paginator-link",
    attrs: {
      "to": {
        query: _vm.queryParams
      }
    }
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.text))])], 2) : _c('a', {
    staticClass: "paginator-link",
    class: {
      active: _vm.active
    },
    on: {
      "click": _vm.changePage
    }
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.text))])], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47ebad40","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/PaginatorLink.vue
// module id = 1971
// module chunks = 0